'use client';
import { useState } from 'react';
import { InputField, InputFieldProps } from '../InputField';
import { FontIcon } from '../../FontIcon';

/**
 * Input field with type='password' and show/hide password logic
 */
export const PasswordInputField = (props: InputFieldProps) => {
    const [passwordInputType, setPasswordInputType] = useInputType();

    const iconClickHandler = () => setPasswordInputType();
    const title = `${passwordInputType === 'text' ? 'Hide' : 'Show'} password`;
    const iconName = passwordInputType === 'text' ? 'eye-off' : 'eye';

    const icon = (
        <span title={title} onClick={iconClickHandler}>
            <FontIcon name={iconName} size="medium" />
        </span>
    );

    return <InputField type={passwordInputType} icon={icon} {...props} />;
};

type HookType = () => ['text' | 'password', () => void];
/**
 * Toggling between 'text' and 'password' when user clicks show/hide password icon
 */
const useInputType: HookType = () => {
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const inputType = isPasswordVisible ? 'text' : 'password';
    const setInputType = () => setIsPasswordVisible(!isPasswordVisible);

    return [inputType, setInputType];
};
